import { AutoColumn } from 'components/Column'
import CurrencyInputPanel from 'components/CurrencyInputPanel'
import Input from 'components/NumericalInput'
import { BodyWrapper } from 'pages/AppBody'
import styled from 'styled-components/macro'

export const PageWrapper = styled(BodyWrapper)<{ wide: boolean }>`
  max-width: ${({ wide }) => (wide ? '1160px' : '480px')};
  width: 100%;
  padding: 0;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.backgroundOutline};
  border-radius: 24px;
  box-shadow: 0 18px 56px rgba(12, 18, 38, 0.1);

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToMedium`
    max-width: 480px;
  `};
`

export const Wrapper = styled.div`
  position: relative;
  padding: 0;
  min-width: 480px;

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToMedium`
    min-width: 400px;
  `};

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToExtraSmall`
  min-width: 340px;
`};
`

export const ScrollablePage = styled.div`
  padding: 48px 24px;
  position: relative;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToMedium`
    max-width: 480px;
    margin: 0 auto;
  `};

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.md}px`}) {
    padding: 48px 8px 0px;
  }

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.sm}px`}) {
    padding-top: 20px;
  }
`

export const DynamicSection = styled(AutoColumn)<{ disabled?: boolean }>`
  opacity: ${({ disabled }) => (disabled ? '0.2' : '1')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};
`

export const CurrencyDropdown = styled(CurrencyInputPanel)`
  flex: 1 1 0;
  width: auto;
  min-width: 0;

  .open-currency-select-button {
    min-width: 0;
    max-width: 100%;
    padding: 0 6px;
  }

  .open-currency-select-button > span,
  .open-currency-select-button > span > div {
    min-width: 0;
  }

  .token-symbol-container,
  .pair-name-container {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 15px;
  }
`

export const StyledInput = styled(Input)`
  background-color: ${({ theme }) => theme.backgroundSurface};
  text-align: left;
  font-size: 18px;
  width: 100%;
`

/* two-column layout where DepositAmount is moved at the very end on mobile. */
export const ResponsiveTwoColumns = styled.div<{ wide: boolean }>`
  display: grid;
  grid-column-gap: 0;
  grid-row-gap: 0;
  grid-template-columns: ${({ wide }) => (wide ? '328px minmax(0, 1fr)' : '1fr')};
  grid-template-rows: max-content;
  grid-auto-flow: row;
  border-top: 1px solid ${({ theme }) => theme.backgroundInteractive};
  background: ${({ theme }) => theme.backgroundSurface};

  > div:first-child {
    align-self: start;
    gap: 12px;
    padding: 18px;
    border-right: ${({ wide, theme }) => (wide ? `1px solid ${theme.backgroundInteractive}` : 'none')};
  }

  ${({ wide }) =>
    !wide &&
    `
      > div:not(:first-child) {
        padding: 0 24px 32px;
      }
    `}

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToMedium`
    grid-template-columns: 1fr;
    margin-top: 0;

    > div:first-child {
      border-right: 0;
      border-bottom: 1px solid ${theme.backgroundInteractive};
    }
  `};
`

export const RightContainer = styled(AutoColumn)`
  grid-row: 1;
  grid-column: 2;
  height: fit-content;
  min-width: 0;
  padding: 28px 28px 32px;

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToMedium`
  grid-row: 2 / 3;
  grid-column: 1;
  `};
`

export const DeployedAmountContainer = styled.div`
  margin-top: 8px;
  padding-top: 28px;
  border-top: 1px solid ${({ theme }) => theme.backgroundInteractive};
`

export const PositionOverviewHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 4px;
`

export const OverviewEyebrow = styled.div`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
  line-height: 18px;
  margin-top: 8px;
`

export const OverviewPrice = styled.div`
  color: ${({ theme }) => theme.textPrimary};
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: -0.025em;
`

export const StackedContainer = styled.div`
  display: grid;
`

export const StackedItem = styled.div<{ zIndex?: number }>`
  grid-column: 1;
  grid-row: 1;
  height: 100%;
  z-index: ${({ zIndex }) => zIndex};
`

export const MediumOnly = styled.div`
  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToMedium`
    display: none;
  `};
`
